import { render, staticRenderFns } from "./SyncBlockContainer.vue?vue&type=template&id=3cbf48b4&scoped=true"
import script from "./SyncBlockContainer.vue?vue&type=script&lang=js"
export * from "./SyncBlockContainer.vue?vue&type=script&lang=js"
import style0 from "./SyncBlockContainer.vue?vue&type=style&index=0&id=3cbf48b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf48b4",
  null
  
)

export default component.exports